import {MODULOS, ROLES, TIPOS_FACTURACION_PERMITIDOS} from './permisos'

const ROLES_PORTAL = [ROLES.ADMINISTRATIVO, ROLES.MEDICO, ROLES.SALUD]
const ROLES_ADMINISTRATIVOS = [ROLES.ADMINISTRATIVO, ROLES.SALUD]
const CONTADO_Y_CREDITO = [
  TIPOS_FACTURACION_PERMITIDOS.CONTADO,
  TIPOS_FACTURACION_PERMITIDOS.CREDITO,
]

// Si `tiposFacturacion` no está definido, el módulo no impone una restricción
// adicional por tipo de facturación.
export const MATRIZ_PERMISOS = Object.freeze({
  [MODULOS.DESCARGA_MASIVA]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: CONTADO_Y_CREDITO,
  },
  [MODULOS.PAGAR_OTROS_SERVICIOS]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
  },
  [MODULOS.CREAR_ORDEN]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: CONTADO_Y_CREDITO,
  },
  [MODULOS.ORDENES_MASIVAS]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: CONTADO_Y_CREDITO,
  },
  [MODULOS.GESTION_ORDENES]: {
    roles: ROLES_PORTAL,
    tiposFacturacion: CONTADO_Y_CREDITO,
  },
  [MODULOS.GESTION_ATENCIONES]: {roles: ROLES_PORTAL},
  [MODULOS.REPORTE_DETALLE_MOVIMIENTO]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
  },
  [MODULOS.VER_DETALLE_MOVIMIENTO]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
  },
  [MODULOS.RECARGAR_CUENTA]: {
    roles: ROLES_ADMINISTRATIVOS,
    tiposFacturacion: [TIPOS_FACTURACION_PERMITIDOS.CONTADO],
  },
  [MODULOS.HOME]: {roles: ROLES_PORTAL},
  [MODULOS.VER_PACIENTES]: {roles: ROLES_PORTAL},
})
